<section class="perfil-cadastro">
  <app-back-button data-testid="perfil-cadastro-voltar" (back)="voltar()" />

  <header class="perfil-cadastro__header">
    <h1 class="perfil-cadastro__title" data-testid="perfil-cadastro-title">
      {{ pageTitle }}
    </h1>

    <div
      class="perfil-cadastro__status-toggle"
      role="group"
      aria-label="Status do perfil"
      data-testid="perfil-cadastro-status-toggle"
    >
      @if (isEditMode && !edicaoBloqueada()) {
        <button
          type="button"
          class="perfil-cadastro__status-btn"
          [class.perfil-cadastro__status-btn--active]="statusAtual() === 'Inativo'"
          [attr.aria-pressed]="statusAtual() === 'Inativo'"
          data-testid="perfil-cadastro-desativar"
          (click)="toggleDesativar()"
        >
          @if (statusAtual() === 'Inativo') {
            Desativado
          } @else {
            Desativar
          }
        </button>
      }
    </div>
  </header>

  @if (edicaoBloqueada()) {
    <div class="perfil-cadastro__bloqueio" role="status">
      <span class="perfil-cadastro__bloqueio-icone" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="5" y="11" width="14" height="10" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      </span>
      <div class="perfil-cadastro__bloqueio-texto">
        <strong class="perfil-cadastro__bloqueio-titulo">Somente visualização</strong>
        <p class="perfil-cadastro__bloqueio-motivo" data-testid="perfil-cadastro-bloqueio-edicao">
          {{ motivoBloqueioEdicao() }}
        </p>
      </div>
    </div>
  }

  <form
    [formGroup]="form"
    class="perfil-cadastro__form"
    data-testid="perfil-cadastro-form"
    (ngSubmit)="salvar()"
  >
    <!-- 1. Configurações gerais -->
    <section
      class="perfil-cadastro__section"
      aria-labelledby="perfil-cadastro-section-1"
    >
      <h2 id="perfil-cadastro-section-1" class="perfil-cadastro__section-title">
        1. Configurações gerais
      </h2>

      <div class="perfil-cadastro__grid">
        <div class="perfil-cadastro__field">
          <label class="perfil-cadastro__label" for="perfil-cadastro-nome">
            Nome do perfil
            <span class="perfil-cadastro__required" aria-hidden="true">*</span>
          </label>
          <input
            id="perfil-cadastro-nome"
            type="text"
            class="perfil-cadastro__control"
            formControlName="nome"
            autocomplete="off"
            aria-required="true"
            data-testid="perfil-cadastro-nome"
            [class.perfil-cadastro__control--invalid]="showControlError('nome')"
            [attr.aria-invalid]="showControlError('nome')"
            [attr.aria-describedby]="
              showControlError('nome') ? 'perfil-cadastro-nome-error' : null
            "
          />
          @if (showControlError('nome')) {
            <span
              id="perfil-cadastro-nome-error"
              class="perfil-cadastro__error"
              role="alert"
              data-testid="perfil-cadastro-nome-error"
            >
              Informe o nome do perfil.
            </span>
          }
        </div>

        <div class="perfil-cadastro__field">
          <label
            class="perfil-cadastro__label"
            for="perfil-cadastro-nome-exibicao"
          >
            Nome de exibição do perfil (opcional)
          </label>
          <input
            id="perfil-cadastro-nome-exibicao"
            type="text"
            class="perfil-cadastro__control"
            formControlName="nomeExibicao"
            autocomplete="off"
            data-testid="perfil-cadastro-nome-exibicao"
          />
        </div>

        <div class="perfil-cadastro__field perfil-cadastro__field--full">
          <label class="perfil-cadastro__label" for="perfil-cadastro-descricao">
            Descrição do perfil
            <span class="perfil-cadastro__required" aria-hidden="true">*</span>
          </label>
          <textarea
            id="perfil-cadastro-descricao"
            class="perfil-cadastro__control perfil-cadastro__textarea"
            formControlName="descricao"
            rows="4"
            aria-required="true"
            [attr.maxlength]="descricaoMaxLength"
            data-testid="perfil-cadastro-descricao"
            [class.perfil-cadastro__control--invalid]="showControlError('descricao')"
            [attr.aria-invalid]="showControlError('descricao')"
            [attr.aria-describedby]="
              showControlError('descricao') ? 'perfil-cadastro-descricao-error' : null
            "
          ></textarea>
          <span
            class="perfil-cadastro__counter"
            aria-hidden="true"
            data-testid="perfil-cadastro-descricao-contador"
          >
            {{ descricaoLength() }}/{{ descricaoMaxLength }}
          </span>
          @if (showControlError('descricao')) {
            <span
              id="perfil-cadastro-descricao-error"
              class="perfil-cadastro__error"
              role="alert"
              data-testid="perfil-cadastro-descricao-error"
            >
              @if (form.get('descricao')?.hasError('maxlength')) {
                A descrição deve ter no máximo {{ descricaoMaxLength }} caracteres.
              } @else {
                Informe a descrição do perfil.
              }
            </span>
          }
        </div>
      </div>
    </section>

    <!-- 2. Adicione categorias para o perfil -->
    <section
      class="perfil-cadastro__section"
      aria-labelledby="perfil-cadastro-section-2"
    >
      <h2 id="perfil-cadastro-section-2" class="perfil-cadastro__section-title">
        2. Adicione categorias para o perfil
        <span class="perfil-cadastro__required" aria-hidden="true">*</span>
      </h2>

      <div class="perfil-cadastro__categoria-add" [formGroup]="novaCategoria">
        <div class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--cor">
          <span class="perfil-cadastro__label" id="perfil-cadastro-nova-cor-label">
            Cor
          </span>
          <div
            class="perfil-cadastro__color-select"
            [class.perfil-cadastro__color-select--open]="corDropdownAberto()"
          >
            <button
              type="button"
              id="perfil-cadastro-nova-cor"
              class="perfil-cadastro__color-trigger"
              aria-haspopup="listbox"
              aria-labelledby="perfil-cadastro-nova-cor-label"
              [attr.aria-expanded]="corDropdownAberto()"
              data-testid="perfil-cadastro-nova-cor"
              [disabled]="edicaoBloqueada()"
              (click)="toggleCorDropdown($event)"
            >
              <span
                class="perfil-cadastro__swatch"
                aria-hidden="true"
                [style.background-color]="corAtual()"
              ></span>
              <span class="perfil-cadastro__color-label">{{ corAtualLabel() }}</span>
              <span class="perfil-cadastro__color-caret" aria-hidden="true"></span>
            </button>

            @if (corDropdownAberto()) {
              <ul
                class="perfil-cadastro__color-options"
                role="listbox"
                aria-label="Cor da categoria"
              >
                @for (cor of coresDisponiveis; track cor.valor) {
                  <li role="option" [attr.aria-selected]="corAtual() === cor.valor">
                    <button
                      type="button"
                      class="perfil-cadastro__color-option"
                      [class.perfil-cadastro__color-option--active]="corAtual() === cor.valor"
                      [attr.data-testid]="'perfil-cadastro-cor-' + cor.valor"
                      (click)="selecionarCor(cor.valor)"
                    >
                      <span
                        class="perfil-cadastro__swatch"
                        aria-hidden="true"
                        [style.background-color]="cor.valor"
                      ></span>
                      <span class="perfil-cadastro__color-option-label">{{ cor.label }}</span>
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        </div>

        <div class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--nome">
          <label class="perfil-cadastro__label" for="perfil-cadastro-nova-nome">
            Nome Categoria
          </label>
          <input
            id="perfil-cadastro-nova-nome"
            type="text"
            class="perfil-cadastro__control"
            formControlName="nome"
            autocomplete="off"
            data-testid="perfil-cadastro-nova-nome"
            [class.perfil-cadastro__control--invalid]="showNovaCategoriaError('nome')"
          />
        </div>

        <div class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--valor">
          <label class="perfil-cadastro__label" for="perfil-cadastro-nova-valor">
            Valor (%)
          </label>
          <input
            id="perfil-cadastro-nova-valor"
            type="number"
            min="0"
            max="100"
            class="perfil-cadastro__control"
            formControlName="valor"
            data-testid="perfil-cadastro-nova-valor"
            [class.perfil-cadastro__control--invalid]="showNovaCategoriaError('valor')"
          />
        </div>

        <div class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--acao">
          <button
            type="button"
            class="perfil-cadastro__icon-btn perfil-cadastro__icon-btn--add"
            aria-label="Adicionar categoria"
            data-testid="perfil-cadastro-adicionar-categoria"
            [disabled]="edicaoBloqueada()"
            (click)="adicionarCategoria()"
          >
            +
          </button>
        </div>
      </div>

      @if (showNovaCategoriaError('nome') || showNovaCategoriaError('valor')) {
        <p
          class="perfil-cadastro__error"
          role="alert"
          data-testid="perfil-cadastro-nova-categoria-error"
        >
          Informe um nome e um valor entre 0 e 100 para adicionar a categoria.
        </p>
      }
    </section>

    <!-- Categorias adicionadas -->
    <section
      class="perfil-cadastro__section"
      aria-labelledby="perfil-cadastro-categorias-title"
    >
      <h2
        id="perfil-cadastro-categorias-title"
        class="perfil-cadastro__section-title"
      >
        Categorias adicionadas
      </h2>

      @if (semCategorias()) {
        <!-- O salvar fica desabilitado nesse estado, então a frase diz o que falta em vez de só
             constatar que a lista está vazia. -->
        <p class="perfil-cadastro__hint" data-testid="perfil-cadastro-sem-categorias">
          Adicione ao menos uma categoria para salvar o perfil.
        </p>
      } @else {
        <ul
          class="perfil-cadastro__categoria-list"
          data-testid="perfil-cadastro-categorias"
        >
          <li class="perfil-cadastro__categoria-row perfil-cadastro__categoria-row--head" aria-hidden="true">
            <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--cor">Cor</span>
            <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--nome">Nome Categoria</span>
            <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--valor">Valor (%)</span>
            <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--acao"></span>
          </li>

          @for (categoria of categorias(); track $index) {
            <li class="perfil-cadastro__categoria-row">
              <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--cor">
                <span
                  class="perfil-cadastro__swatch perfil-cadastro__swatch--lg"
                  aria-hidden="true"
                  [style.background-color]="categoria.cor"
                ></span>
                <label class="perfil-cadastro__sr-only" [attr.for]="'perfil-cadastro-cat-cor-' + $index">
                  Cor da categoria {{ $index + 1 }}
                </label>
                <select
                  [id]="'perfil-cadastro-cat-cor-' + $index"
                  class="perfil-cadastro__control perfil-cadastro__control--cor"
                  [value]="categoria.cor"
                  [attr.data-testid]="'perfil-cadastro-cat-cor-' + $index"
                  [disabled]="edicaoBloqueada()"
                  (change)="atualizarCorCategoria($index, $any($event.target).value)"
                >
                  @for (cor of coresDisponiveis; track cor.valor) {
                    <option [value]="cor.valor" [selected]="cor.valor === categoria.cor">
                      {{ cor.label }}
                    </option>
                  }
                </select>
              </span>

              <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--nome">
                <label class="perfil-cadastro__sr-only" [attr.for]="'perfil-cadastro-cat-nome-' + $index">
                  Nome da categoria {{ $index + 1 }}
                </label>
                <input
                  [id]="'perfil-cadastro-cat-nome-' + $index"
                  type="text"
                  class="perfil-cadastro__control"
                  [value]="categoria.nomeCategoria"
                  [attr.data-testid]="'perfil-cadastro-cat-nome-' + $index"
                  [disabled]="edicaoBloqueada()"
                  (input)="atualizarNomeCategoria($index, $any($event.target).value)"
                />
              </span>

              <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--valor">
                <label class="perfil-cadastro__sr-only" [attr.for]="'perfil-cadastro-cat-valor-' + $index">
                  Valor da categoria {{ $index + 1 }}
                </label>
                <input
                  [id]="'perfil-cadastro-cat-valor-' + $index"
                  type="number"
                  min="0"
                  max="100"
                  class="perfil-cadastro__control"
                  [value]="categoria.valorPercentual"
                  [attr.data-testid]="'perfil-cadastro-cat-valor-' + $index"
                  [disabled]="edicaoBloqueada()"
                  (input)="atualizarValorCategoria($index, $any($event.target).value)"
                />
              </span>

              <span class="perfil-cadastro__categoria-col perfil-cadastro__categoria-col--acao">
                <button
                  type="button"
                  class="perfil-cadastro__icon-btn perfil-cadastro__icon-btn--remove"
                  [attr.aria-label]="'Remover ' + categoria.nomeCategoria"
                  [attr.data-testid]="'perfil-cadastro-remover-categoria-' + $index"
                  [disabled]="edicaoBloqueada()"
                  (click)="removerCategoria($index)"
                >
                  −
                </button>
              </span>
            </li>
          }
        </ul>

        <!-- Distribuição de categorias -->
        <div
          class="perfil-cadastro__distribuicao"
          data-testid="perfil-cadastro-distribuicao"
        >
          <svg
            class="perfil-cadastro__chart"
            viewBox="0 0 32 32"
            role="img"
            aria-label="Gráfico de distribuição das categorias"
          >
            @for (slice of pieSlices(); track $index) {
              <circle
                class="perfil-cadastro__chart-slice"
                cx="16"
                cy="16"
                r="8"
                fill="none"
                stroke-width="16"
                [attr.pathLength]="pathLength"
                [attr.stroke]="slice.cor"
                [attr.stroke-dasharray]="slice.dashArray"
                [attr.stroke-dashoffset]="slice.dashOffset"
              ></circle>
            }
          </svg>

          <div class="perfil-cadastro__distribuicao-info">
            <h3 class="perfil-cadastro__distribuicao-title">
              Distribuição de categorias
            </h3>
            <ul class="perfil-cadastro__distribuicao-list">
              @for (categoria of categorias(); track $index) {
                <li class="perfil-cadastro__distribuicao-item">
                  <span
                    class="perfil-cadastro__swatch"
                    aria-hidden="true"
                    [style.background-color]="categoria.cor"
                  ></span>
                  <span class="perfil-cadastro__distribuicao-nome">
                    {{ categoria.nomeCategoria }}:
                  </span>
                  <span class="perfil-cadastro__distribuicao-valor">
                    {{ categoria.valorPercentual }}%
                  </span>
                </li>
              }
            </ul>

            @if (distribuicaoInvalida()) {
              <p
                class="perfil-cadastro__error"
                role="alert"
                data-testid="perfil-cadastro-total-error"
              >
                A soma das categorias deve ser 100% (atual: {{ totalValor() }}%).
              </p>
            }
          </div>
        </div>
      }
    </section>

    <footer class="perfil-cadastro__footer">
      <div class="perfil-cadastro__footer-actions">
        <button
          type="button"
          class="perfil-cadastro__footer-btn perfil-cadastro__footer-btn--cancelar"
          data-testid="perfil-cadastro-cancelar"
          (click)="onCancelar()"
        >
          Cancelar
        </button>
        @if (!edicaoBloqueada()) {
          <button
            type="submit"
            class="btn-primary perfil-cadastro__footer-btn"
            data-testid="perfil-cadastro-salvar"
            [disabled]="!podeSalvar()"
          >
            {{ salvarLabel }}
          </button>
        }
      </div>

      @if (isEditMode && !edicaoBloqueada()) {
        <button
          type="button"
          class="perfil-cadastro__excluir-link"
          data-testid="perfil-cadastro-excluir"
          (click)="onExcluir()"
        >
          Excluir Perfil
        </button>
      }
    </footer>
  </form>

  @if (categoriaParaExcluir(); as categoria) {
    <app-alert-dialog
      title="Excluir categoria"
      [message]="'Deseja realmente excluir a categoria ' + categoria.nomeCategoria + '?'"
      description="A distribuição do perfil será recalculada sem ela."
      confirmLabel="Excluir"
      cancelLabel="Cancelar"
      (confirm)="confirmarExclusaoCategoria()"
      (cancel)="cancelarExclusaoCategoria()"
    />
  }

  @if (avisoNomeExibicaoVazio()) {
    <app-alert-dialog
      title="Nome de exibição vazio"
      message="O nome de exibição do perfil não foi preenchido."
      [confirmLabel]="salvarLabel"
      cancelLabel="Voltar"
      (confirm)="confirmarNomeExibicaoVazio()"
      (cancel)="cancelarNomeExibicaoVazio()"
    >
      <strong data-testid="perfil-cadastro-aviso-nome-exibicao">
        O nome exibido para o participante será o nome do perfil: {{ form.getRawValue().nome }}
      </strong>
    </app-alert-dialog>
  }
</section>
